import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { ICopyPanelButtonProps } from './types';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { COPY_SECTION_TITLE } from '../CopySection/constants';

export function CopyPanelButton ({
    onClick
}: ICopyPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.COPY}
            title={COPY_SECTION_TITLE}
            onClick={() => {
                setSubTab(EBoardSetting.COPY);
                onClick();
            }}
        />
    );
}
